// Banner.js

import React, { Component } from 'react';
import { Button, Form, Table, Container, Row, Col, ButtonToolbar, Overlay, Popover } from 'react-bootstrap';
import Config from '../Config';

const ProductLocals = ["Eng", "Kor", "Jpn", "Chn", "Esp", "Fra"];

class RowItem extends Component {
    static defaultProps = {
        item: null,
        enable: false,
        onPress: () => { },
    }
    constructor(props) {
        super(props);
        this.state = {
            answervisible: false
        };
    }

    handleRowClick = () => {
        this.props.onPress(this.props.item);
        event.preventDefault();
    }
    render() {
        return (
            <tr onClick={this.handleRowClick}>
                <td>{this.props.item.ID}</td>
                <td>{this.props.item.FILENAME}</td>
                <td>{this.props.item.PCODEURL}</td>
                <td>{this.props.item.LANG}</td>
                <td>{this.props.item.TITLE}</td>
                <td>{this.props.item.CONTENT}</td>
                <td>{this.props.item.ARTIST}</td>
                <td>{this.props.item.USE_FLAG}</td>
                <td>{this.props.item.REVIEW_FLAG}</td>
                <td>{this.props.item.UPDATETIME}</td>
            </tr>
        );
    }
};

export default class Banner extends Component {
    constructor(props) {
        super(props);
        this.locals = ProductLocals;
        this.default = { FILENAME: '파일명', PCODEURL: '연결 웹사이트 주소', LANG: 'Kor', TITLE: '제목', CONTENT: '상세 내용', ARTIST: 'ARTIST', USE_FLAG: 1 , REVIEW_FLAG : 1 };
        this.state = {
            sendcount: 0,
            rowlist: [],
            answervisible: false,
            item: { ...this.default },
            language: this.locals[0]
        };

        this.handleChangeREVIEW_FLAG = this.handleChangeREVIEW_FLAG.bind(this);

        this.handleChangeFILENAME = this.handleChangeFILENAME.bind(this);
        this.handleChangeUSE_FLAG = this.handleChangeUSE_FLAG.bind(this);
        this.handleChangePCODEURL = this.handleChangePCODEURL.bind(this);
        this.handleChangeLanguage = this.handleChangeLanguage.bind(this);
        this.handleChangeTITLE = this.handleChangeTITLE.bind(this);
        this.handleChangeCONTENT = this.handleChangeCONTENT.bind(this);
        this.handleChangeARTIST = this.handleChangeARTIST.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleModify = this.handleModify.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
    }

    handleReset(event) {
        this.setState({ item: { ...this.default } })
    }

    handleChangeFILENAME(event) {
        var item = this.state.item;
        item.FILENAME = event.target.value;
        this.setState({ item: item });
    }

    handleChangeREVIEW_FLAG(event) {
        var item = this.state.item;
        item.REVIEW_FLAG = event.target.value;
        this.setState({ item: item });
    }

    handleChangeUSE_FLAG(event) {
        var item = this.state.item;
        item.USE_FLAG = event.target.value;
        this.setState({ item: item });
    }

    handleChangePCODEURL(event) {
        var item = this.state.item;
        item.PCODEURL = event.target.value;
        this.setState({ item: item });
    }

    handleChangeLanguage(event) {
        var item = this.state.item;
        item.LANG = event.target.value;
        this.setState({ language: event.target.value }, () => {
            this.setState({ item: item });
        });
    }

    handleChangeTITLE(event) {
        var item = this.state.item;
        item.TITLE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeCONTENT(event) {
        var item = this.state.item;
        item.CONTENT = event.target.value;
        this.setState({ item: item });
    }

    handleChangeARTIST(event) {
        var item = this.state.item;
        item.ARTIST = event.target.value;
        this.setState({ item: item });
    }

    fetchData(address, params, callback, revalidate = false, cbError) {

        var chcheoption = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (revalidate) {
            // chcheoption['Cache-Control'] = 'must-revalidate';
        }

        fetch(`${Config.Server}/${address}`, {
            // mode: 'no-cors',
            method: 'POST',
            headers: chcheoption,
            body: JSON.stringify(params)
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                if (callback)
                    callback(responseJson.result, responseJson.count);
            })
            .catch((error) => {
                console.error(error);
                cbError(error);
            });
    }

    handleSubmit(event) {

        this.fetchData('insbanner', {
            FILENAME: this.state.item.FILENAME,
            PCODEURL: this.state.item.PCODEURL,
            LANG: this.state.item.LANG,
            TITLE: this.state.item.TITLE,
            CONTENT: this.state.item.CONTENT,
            ARTIST: this.state.item.ARTIST,
            USE_FLAG: this.state.item.USE_FLAG,
            REVIEW_FLAG: this.state.item.REVIEW_FLAG
        }, (result, count) => {
            console.log('insbanner=', count);
            this.setState({ sendcount: count })
            this.componentDidMount();
        }, true);

        event.preventDefault();
    }

    handleModify(event) {

        this.fetchData('modbanner', {
            ID: this.state.item.ID,
            FILENAME: this.state.item.FILENAME,
            PCODEURL: this.state.item.PCODEURL,
            LANG: this.state.item.LANG,
            TITLE: this.state.item.TITLE,
            CONTENT: this.state.item.CONTENT,
            ARTIST: this.state.item.ARTIST,
            USE_FLAG: this.state.item.USE_FLAG,
            REVIEW_FLAG: this.state.item.REVIEW_FLAG
        }, (result, count) => {
            console.log('modbanner=', count);
            this.setState({ sendcount: count })
            this.componentDidMount();

        }, true);

        event.preventDefault();
    }

    handleRemove(event) {

        this.fetchData('delbanner', {
            ID: this.state.item.ID
        }, (result, count) => {
            console.log('delbanner=', count);
            this.setState({ sendcount: count })
            this.componentDidMount();

        }, true);

        event.preventDefault();
    }

    handleRowClick = (item) => {
        // alert(item);
        var edititem = { ...item };
        edititem.FILENAME = item.FILENAME;
        edititem.PCODEURL = item.PCODEURL;
        edititem.TITLE = item.TITLE;
        edititem.CONTENT = item.CONTENT;
        edititem.USE_FLAG = item.USE_FLAG;
        edititem.REVIEW_FLAG = item.REVIEW_FLAG;
        this.setState({ item: edititem });
        this.setState({ answervisible: true });
        event.preventDefault();
    }

    componentDidMount() {
        this.fetchData('bannersall', {
        }, (result, count) => {
            console.log('count=', count);
            this.setState({ rowlist: result })
        }, true);
    }

    render() {
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <h3 className="box-title">배너 등록/수정</h3>
                                </div>
                                <div className="box-body" style={{ margin: 20 }}>
                                    <div className="row">

                                        <Form>
                                            <div className="row" style={{ margin: 0 }}>
                                                <div className="col-md-6">
                                                    <Form.Group controlId="exampleForm.ControlInput1">
                                                        <Form.Label>ID: {this.state.item.ID} </Form.Label>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-6">
                                                    <Form.Group controlId="exampleForm.ControlSelect1">
                                                        <Form.Label>검수중</Form.Label>
                                                        <Form.Control as="select" value={this.state.item.REVIEW_FLAG} onChange={this.handleChangeREVIEW_FLAG}>
                                                            <option>0</option>
                                                            <option>1</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </div>
                                            </div>
                                            <div className="row" style={{ margin: 0 }}>
                                                <div className="col-md-6">
                                                    <Form.Group controlId="exampleForm.ControlInput1">
                                                        <Form.Label>파일명</Form.Label>
                                                        <Form.Control type="title" placeholder="파일명" value={this.state.item.FILENAME} onChange={this.handleChangeFILENAME} />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-6">
                                                    <Form.Group controlId="exampleForm.ControlSelect1">
                                                        <Form.Label>사용여부</Form.Label>
                                                        <Form.Control as="select" value={this.state.item.USE_FLAG} onChange={this.handleChangeUSE_FLAG}>
                                                            <option>0</option>
                                                            <option>1</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </div>
                                            </div>

                                            <div className="row" style={{ margin: 0 }}>
                                                <div className="col-md-6">
                                                    <Form.Group controlId="exampleForm.ControlInput1">
                                                        <Form.Label>PCODE or URL</Form.Label>
                                                        <Form.Control type="title" placeholder="PCODE" value={this.state.item.PCODEURL} onChange={this.handleChangePCODEURL} />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-6">
                                                    <Form.Group as={Col} controlId="exampleForm.ControlSelect1">
                                                        <Form.Label>언어선택</Form.Label>
                                                        <Form.Control as="select" value={this.state.item.LANG} onChange={this.handleChangeLanguage}>
                                                            {this.locals.map((item, index) =>
                                                                <option>{item}</option>
                                                            )}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </div>
                                            </div>
                                            <Form.Group controlId="exampleForm.ControlInput1">
                                                <Form.Label>제목</Form.Label>
                                                <Form.Control as="textarea" rows="2" placeholder="제목" value={this.state.item.TITLE} onChange={this.handleChangeTITLE} />
                                            </Form.Group>
                                            <Form.Group controlId="exampleForm.ControlTextarea1">
                                                <Form.Label>내용</Form.Label>
                                                <Form.Control as="textarea" rows="2" placeholder="내용" value={this.state.item.CONTENT} onChange={this.handleChangeCONTENT} />
                                            </Form.Group>
                                            <Form.Group controlId="exampleForm.ControlInput1">
                                                <Form.Label>ARTIST</Form.Label>
                                                <Form.Control type="title" placeholder="ARTIST" value={this.state.item.ARTIST} onChange={this.handleChangeARTIST} />
                                            </Form.Group>
                                            <Button variant="primary" onClick={this.handleSubmit}>추가</Button>
                                            <Button variant="primary" onClick={this.handleModify}>수정</Button>
                                            <Button variant="primary" onClick={this.handleReset}>리셋</Button>
                                            <Button variant="primary" onClick={this.handleRemove}>삭제</Button>
                                        </Form>

                                    </div>
                                    <div className="row">
                                        <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>파일명</th>
                                                    <th>PCODE 또는 URL</th>
                                                    <th>LANG</th>
                                                    <th>제목</th>
                                                    <th>내용</th>
                                                    <th>ARTIST</th>
                                                    <th>사용여부</th>
                                                    <th>검수중</th>
                                                    <th>수정일</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.rowlist.map((item, index) =>
                                                    <RowItem key={index} item={item} onPress={this.handleRowClick} />
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-6">
                                            <div className="description-block border-right">
                                                {/* <span className="description-percentage text-green"><i className="fa fa-caret-up"></i> 17%</span> */}
                                                {/* <h5 className="description-header">Sending TOTAL: {this.state.sendcount}</h5> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/components/Banner.js